<template>
  <div class="ComponentSticky InstanceTipicoCasinoSticky StickyWrapper ">
    <section class="TipicoSticky InstanceTipicoSearchfieldWrapper ComponentLayout Layout">
      <div class="TipicoSW ComponentLayout InstanceTipicoSearchfieldWrapper Layout">
        <div class="SearchTrigger ComponentLayout InstanceCasinoSearchWrapper Layout">
          <gameSearch v-on:result="getSearchGameList" />
        </div>
      </div>
      <div class="card-carousel-wrapper HorizontalScrollWrapper">
        <button type="button" class="HorizontalScrollBtn" disabled="" @click="moveCarousel(-1)" :disabled="atHeadOfList">
            <span class="ComponentIcon Icon">
               <span class="SvgIcon MainIcon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.63 55.06">
                     <g data-name="Layer 2">
                        <path d="M34.63 27.53L31.09 24l-24-24L0 7.06l20.47 20.47L0 48l7.09 7.06 24-24 3.54-3.53z" data-name="Layer 1"></path>
                     </g>
                  </svg>
               </span>
            </span>
        </button>
        <div class="card-carousel TipicoCasinoCategories ComponentGameCategories InstanceCasino GameNavContainer TipicoCasino">
          <div class="card-carousel--overflow-container GameCategories Loaded CategoriesList HorizontalScrollBar List ListUnordered">
            <div class="card-carousel-cards CategoriesItem ListItem" :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
              <router-link :to="{query: {provider: item.id}}" class="card-carousel--card ComponentAnchor GameCategory Anchor Anchor " v-for="item in items">
                {{ item.name }}
              </router-link>
            </div>
          </div>
        </div>
        <button type="button" class="HorizontalScrollBtn" @click="moveCarousel(1)" :disabled="atEndOfList">
            <span class="ComponentIcon Icon">
               <span class="SvgIcon MainIcon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.63 55.06">
                     <g data-name="Layer 2">
                        <path d="M34.63 27.53L31.09 24l-24-24L0 7.06l20.47 20.47L0 48l7.09 7.06 24-24 3.54-3.53z" data-name="Layer 1"></path>
                     </g>
                  </svg>
               </span>
            </span>
        </button>
      </div>
    </section>
  </div>

</template>

<script>
import gameSearch from "@/components/casino/widget/gameSearch";
export default {
  name: 'carousel',
  components: {gameSearch},
  props: ['live'],
  data() {
    return {
      currentOffset: 0,
      windowSize: 3,
      paginationFactor: 100,
      disabledVendors: [245, 248, 249, 252, 250, 253, 254, 255, 256, 286, 287, 288],
      items: []
    }
  },
  computed: {
    atEndOfList() {
      return this.currentOffset <= (this.paginationFactor * -1) * (this.items.length - this.windowSize);
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  mounted() {
    this.fetchVendor()
  },
  methods: {
    getSearchGameList(r) {
      this.$emit('result', r);
    },
    fetchVendor () {
      this.$http.get(api+'api/v1/casino/providers').then(response => {

        // get body data
        response.body.result.forEach((v) => {

          if(!this.live){
            if(!v.is_live){
              this.items.push(v)
            }
          }else {
            if(v.is_live){
              this.items.push(v)
            }
          }

          this.$emit('provider', this.items)


        })
      })
    },
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$vue-navy: #2c3e50;
$vue-navy-light: #3a5169;
$vue-teal: #42b883;
$vue-teal-light: #42b983;
$gray: #666a73;
$light-gray: #f8f8f8;


body {
  background: $light-gray;
  color: $vue-navy;
  font-family: 'Source Sans Pro', sans-serif;
}

.card-carousel-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  color: $gray;
}

.card-carousel {
  display: flex;
  justify-content: left;

  &--overflow-container {
    overflow: hidden;
  }

  &--nav__left,
  &--nav__right {
    display: inline-block;
    width: 15px;
    height: 15px;
    padding: 10px;
    box-sizing: border-box;
    border-top: 2px solid $vue-teal;
    border-right: 2px solid $vue-teal;
    cursor: pointer;
    margin: 0 20px;
    transition: transform 150ms linear;
    &[disabled] {
      opacity: 0.2;
      border-color: black;
    }
  }

  &--nav__left {
    transform: rotate(-135deg);
    &:active {
      transform: rotate(-135deg) scale(0.9);
    }
  }

  &--nav__right {
    transform: rotate(45deg);
    &:active {
      transform: rotate(45deg) scale(0.9);
    }
  }
}

.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);

  .card-carousel--card {

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }


  }
}

</style>



// WEBPACK FOOTER //
// src/components/ui/carousel.vue